import { BlobServiceClient } from "@azure/storage-blob";
import { AZURE_CONFIG } from "../../config/azure";

const blobStorageClient = new BlobServiceClient(AZURE_CONFIG.BLOB_SERVICE_CLIENT_URL);
const containerClient = blobStorageClient.getContainerClient(AZURE_CONFIG.CONTAINER_NAME);

export const getAzureFilePath = (path = '', option = {}) => {
  const containerUrl = containerClient.url;
  let publicPath = containerUrl.replace(AZURE_CONFIG.CONTAINER_NAME, `${AZURE_CONFIG.CONTAINER_NAME}/${path}`)
  if (option.isRemoveToken) {
    publicPath = publicPath.replace(`?${AZURE_CONFIG.SHARED_ACCESS_SIGNATURE}`, '');
  }
  return publicPath
}

export const getAzureFileList = async (path = '') => {
  const localBlobList = [];
  const prefix = `${AZURE_CONFIG.STORAGE_NAME}${path}`
  for await (const blob of containerClient.listBlobsFlat({
    prefix
  })) {
    localBlobList.push(blob.name);
  }
  console.log('getAzureFileList', prefix, localBlobList)
  return localBlobList;
}

export const azureUploadFile = async (path, file, fileName) => {
  const pathUpload = `${AZURE_CONFIG.STORAGE_NAME}${path}/${fileName}`;
  console.log('==================');
  console.log('azureUploadFile pathUpload', pathUpload, file)
  const blockBlobClient = containerClient.getBlockBlobClient(pathUpload);
  const res = await blockBlobClient.uploadData(file, {
    blobHTTPHeaders: {
      blobContentType: file.type
    }
  });
  console.log(`${getAzureFilePath(pathUpload).replace(/ /g, '%20')} successfully added!`, res, pathUpload, file)
  console.log('==================');
  return pathUpload
}

export const getAzureFileRef = (path) => {
  // ref path for delete
  return path.replace(`${AZURE_CONFIG.BLOB_END_POINT}/${AZURE_CONFIG.CONTAINER_NAME}/`, '').replace(`?${AZURE_CONFIG.SHARED_ACCESS_SIGNATURE}`, '');
}

export const azureDeleteFile = async (path) => {
  if (path) {
    const pathDelete = getAzureFileRef(path)
    console.log('==================');
    console.log('azureDeleteFile pathDelete', pathDelete)
    const blockBlobClient = containerClient.getBlockBlobClient(pathDelete);
    const res = await blockBlobClient.delete();
    console.log(`${pathDelete} successfully deleted!`, res)
    console.log('==================');
  }
}

export const azureUrltoBase64 = async (path = '') => {
  try {
    const blobClient = containerClient.getBlobClient(path);
    const downloadBlockBlobResponse = await blobClient.download();

    const blobToBase64 = async (blob) => {
      const fileReader = new FileReader();
      return new Promise((resolve, reject) => {
        fileReader.onloadend = (ev) => {
          resolve(ev.target.result);
        };
        fileReader.onerror = reject;
        fileReader.readAsDataURL(blob);
      });
    }

    const contentType = downloadBlockBlobResponse.contentType || "image/jpeg";
    const blob = await blobToBase64(new Blob([await downloadBlockBlobResponse.blobBody], { type: contentType }));
    return blob
  } catch (err) {
    console.log('azureUrltoBase64', path, err.message)
  }
}